import {useAppSelector} from "../../../../redux/hooks";
import {mySongsLibraryStore} from "../../../songs-router/modules/my-songs-library-store/mySongsLibrary.store";

export interface IIfSongsPageRequestCompleteLogic {
  isRequestComplete: boolean;
}

export const useIfSongsPageRequestCompleteLogic = (): IIfSongsPageRequestCompleteLogic => {
  const isRequestComplete = useAppSelector(mySongsLibraryStore.getIsRequestCompleted);
  return {
    isRequestComplete,
  };
}
